/**
 * @author bly
 * 功能：库存查询
 */

import { Service } from '@/tools'

export class rackSkuStockService<T extends TStock.rackSkuStock> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(
    url: `${P}/${keyof TStock.rackSkuStock}`,
    data?: TCommon.Json,
    toast?: string
  ) {
    return this.post(url, data, toast)
  }

  /**
   * 模块说明：分页查询架位库存列表
   * /api/stock/rackSkuStock/v1/page
   */
  pageList = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiPage', data)
  }

  /**
   * 模块说明： 根据架位id查询架位库存
   * /api/stock/rackSkuStock/v1/selectByRackId
   */
  selectByRackId = <K extends T['ApiSelectByRackId']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiSelectByRackId', data)
  }

  /**
   * 模块说明： 查询架位批次库存
   * /api/stock/rackSkuStock/v1/selectBatchList
   */
  selectBatchList = <K extends T['ApiSelectBatchList']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiSelectBatchList', data)
  }
  /**
   * 模块说明： 根据架位库存id查询批次库存
   * /api/stock/rackSkuStock/v1/selectBatchListByStockId
   */
  selectBatchListByStockId = <K extends T['ApiSelectBatchListByStockId']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiSelectBatchListByStockId', data)
  }

  /**
   * 模块说明： 获取架位、批次库存数量
   * /api/stock/rackSkuStock/v1/getRackStockNum
   */
  getRackStockNum = <K extends T['ApiGetRackStockNum']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiGetRackStockNum', data)
  }

  /**
   * 模块说明： 批量获取批次库存数量
   * /api/stock/rackSkuStock/v1/getRackBatchStockNum
   */
  getRackBatchStockNum = <K extends T['ApiGetRackBatchStockNum']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiGetRackBatchStockNum', data)
  }
}
